// src/components/my-button/my-button.tsx
/* istanbul ignore file */
import { Host, h } from '@stencil/core';
import KeenSlider from 'keen-slider';
export class AibaCarousel {
  constructor() {
    this.slider = null;
    this.childrenRemoved = false;
    this.renderChildrenSlides = () => {
      var _a, _b, _c, _d, _e, _f;
      if (this.children) {
        if (this.firstLoad) {
          this.swiperContainerRef.innerHTML = '';
          (_b = (_a = this.swiperContainerRef) === null || _a === void 0 ? void 0 : _a.childNodes) === null || _b === void 0 ? void 0 : _b.forEach(item => {
            var _a;
            if (!((_a = item === null || item === void 0 ? void 0 : item.childNodes) === null || _a === void 0 ? void 0 : _a.length))
              item.remove();
          });
          this.children.forEach((ele) => {
            var _a, _b, _c, _d, _e, _f;
            // const child = ele?.$elm$ ? ele?.$elm$ : ele?.m;
            const child = this.findNodeWithKey(ele);
            const sliderDiv = document.createElement('div');
            ((_a = child === null || child === void 0 ? void 0 : child.dataset) === null || _a === void 0 ? void 0 : _a.lable) && this.lableData.push(child.dataset.lable);
            ((_b = child === null || child === void 0 ? void 0 : child.dataset) === null || _b === void 0 ? void 0 : _b.heading) && this.headingData.push(child.dataset.heading);
            ((_c = child === null || child === void 0 ? void 0 : child.dataset) === null || _c === void 0 ? void 0 : _c.score) && this.scoreData.push(child.dataset.score);
            ((_d = child === null || child === void 0 ? void 0 : child.dataset) === null || _d === void 0 ? void 0 : _d.description) && this.descriptionData.push(child.dataset.description);
            sliderDiv.setAttribute('class', 'keen-slider__slide');
            sliderDiv.appendChild(child);
            this.swiperContainerRef.appendChild(sliderDiv);
            (_f = (_e = this.swiperContainerRef) === null || _e === void 0 ? void 0 : _e.childNodes) === null || _f === void 0 ? void 0 : _f.forEach(item => {
              var _a;
              if (!((_a = item === null || item === void 0 ? void 0 : item.childNodes) === null || _a === void 0 ? void 0 : _a.length))
                item.remove();
            });
          });
          this.slidesLength = (_d = (_c = this.swiperContainerRef) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d.length;
          this.initSlider();
          this.firstLoad = false;
        }
      }
      else {
        if (this.firstLoad) {
          if (this.childrenSlidesSwiperRef && this.childrenSlidesSwiperRef.children && !this.childrenRemoved && this.childrenSlidesSwiperRef.children.length) {
            let children = Array.from(this.childrenSlidesSwiperRef.children);
            children.forEach((child) => {
              var _a, _b, _c, _d;
              const sliderDiv = document.createElement('div');
              ((_a = child === null || child === void 0 ? void 0 : child.dataset) === null || _a === void 0 ? void 0 : _a.lable) && this.lableData.push(child.dataset.lable);
              ((_b = child === null || child === void 0 ? void 0 : child.dataset) === null || _b === void 0 ? void 0 : _b.heading) && this.headingData.push(child.dataset.heading);
              ((_c = child === null || child === void 0 ? void 0 : child.dataset) === null || _c === void 0 ? void 0 : _c.score) && this.scoreData.push(child.dataset.score);
              ((_d = child === null || child === void 0 ? void 0 : child.dataset) === null || _d === void 0 ? void 0 : _d.description) && this.descriptionData.push(child.dataset.description);
              sliderDiv.setAttribute('class', 'keen-slider__slide');
              sliderDiv.appendChild(child);
              this.swiperContainerRef.appendChild(sliderDiv);
            });
            this.slidesLength = (_f = (_e = this.swiperContainerRef) === null || _e === void 0 ? void 0 : _e.children) === null || _f === void 0 ? void 0 : _f.length;
            this.childrenRemoved = false;
            this.initSlider();
            this.firstLoad = false;
          }
        }
      }
    };
    this.getInertStateForSlide = index => {
      var _a;
      const slidesPerView = (_a = this.getSlideIndexInfo()) === null || _a === void 0 ? void 0 : _a.slidesPerView;
      if (!this.disableTabbingInNonActiveSlides || !(typeof slidesPerView === 'number')) {
        return false;
      }
      return !(index >= this.currentSlide && index <= this.currentSlide + slidesPerView - 1);
    };
    this.getSlidesPerViewInBreakpoints = () => {
      var _a, _b, _c;
      const breakpoints = (_a = this.sliderProperties) === null || _a === void 0 ? void 0 : _a.breakpoints;
      let slidesPerView = 0;
      if (breakpoints) {
        const breakpointsKeys = Object.keys(this.sliderProperties.breakpoints);
        const userWidth = this.clientWidth;
        let greatestWidth = 0;
        breakpointsKeys.forEach(breakpointKey => {
          var _a, _b;
          const width = parseInt(breakpointKey.split('min-width')[1].split(':')[1]);
          if (userWidth > width && width > greatestWidth) {
            greatestWidth = width;
            slidesPerView = (_b = (_a = breakpoints[breakpointKey]) === null || _a === void 0 ? void 0 : _a.slides) === null || _b === void 0 ? void 0 : _b.perView;
          }
        });
      }
      else {
        slidesPerView = (_c = (_b = this.sliderProperties) === null || _b === void 0 ? void 0 : _b.slides) === null || _c === void 0 ? void 0 : _c.perView;
      }
      return slidesPerView;
    };
    this.handleClickNext = (event) => {
      let slideInfo = this.getSlideIndexInfo();
      let slidesPerView = Math.round(slideInfo.slidesPerView);
      if (this.moveToSliderIndex) {
        if (this.currentSlide === slideInfo.lastIndex - 2 || this.currentSlide === slideInfo.lastIndex) {
          this.slider.moveToIdx(slideInfo.maxIdx);
        }
        else {
          this.slider.moveToIdx(this.currentSlide + slidesPerView);
        }
      }
      else {
        this.slider.next();
      }
      //additional handler from parent
      this.handleSliderNext && this.handleSliderNext(event);
      if (this.currentSlide === this.slidesLength - slideInfo.slidesPerView) {
        this.nextClick.emit(true);
      }
    };
    this.handleClickPrev = (event) => {
      var _a;
      let slideInfo = this.getSlideIndexInfo();
      let slidesPerView = Math.round(slideInfo.slidesPerView);
      if (this.moveToSliderIndex) {
        if (this.currentSlide === slideInfo.lastIndex) {
          this.slider.moveToIdx(slideInfo.lastIndex - 2);
        }
        else {
          this.slider.moveToIdx(this.currentSlide - slidesPerView);
        }
      }
      else {
        this.slider.prev();
      }
      //additional handler from parent
      this.handleSliderPrev && this.handleSliderPrev(event);
      if (!((_a = this.sliderProperties) === null || _a === void 0 ? void 0 : _a.loop)) {
        this.currentSlide === 0 ? this.prevClick.emit(true) : '';
      }
    };
    this.handleMoveToSlideIndex = (index, event) => {
      let slideInfo = this.getSlideIndexInfo();
      let moveToIdx = 0;
      let offSetvalue = 0;
      if (this.handlers && this.handlers.handleDotsClick) {
        this.handlers && this.handlers.handleDotsClick && this.handlers.handleDotsClick(event);
      }
      if (slideInfo.slidesPerView > 1)
        offSetvalue = slideInfo.slidesPerView - 1;
      if (index === 0) {
        moveToIdx = index;
        this.slider.moveToIdx(moveToIdx, true);
      }
      else if ((index === slideInfo.lastIndex - 1 || index === slideInfo.lastIndex) && !isNaN(parseInt(slideInfo.maxIdx))) {
        moveToIdx = slideInfo.maxIdx;
        this.slider.moveToIdx(moveToIdx);
      }
      else if (index !== 0) {
        moveToIdx = index + offSetvalue;
        this.slider.moveToIdx(moveToIdx);
      }
      //set active state for dot
      const dots = this.parentContainerRef.querySelectorAll('.dot');
      if (this.parentContainerRef.querySelector(`.dot-${index}`)) {
        dots.forEach(dot => dot.classList.remove('dot--active'));
        this.parentContainerRef.querySelector(`.dot-${index}`).classList.add('dot--active');
      }
      //additional handler from parent
      this.handleSliderMoveToIndex && this.handleSliderMoveToIndex(index, event);
    };
    /*utility function to get slide last Index, swipe direction*/
    this.getSlideIndexInfo = () => {
      var _a, _b, _c, _d, _e, _f;
      const resultObject = {
        lastIndex: null,
        slidesPerView: null,
        maxIdx: 0,
        minIdx: 0,
      };
      resultObject.maxIdx = (_c = (_b = (_a = this.slider) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.maxIdx;
      resultObject.minIdx = (_f = (_e = (_d = this.slider) === null || _d === void 0 ? void 0 : _d.track) === null || _e === void 0 ? void 0 : _e.details) === null || _f === void 0 ? void 0 : _f.minIdx;
      resultObject.slidesPerView = this.getSlidesPerViewInBreakpoints();
      resultObject.lastIndex = Math.ceil(this.slidesLength / resultObject.slidesPerView);
      return resultObject;
    };
    this.renderArrowsNavigation = (arrowsData) => {
      var _a, _b;
      let slideInfo = this.getSlideIndexInfo();
      if (this.sliderProperties && slideInfo.slidesPerView < this.slidesLength) {
        return (h("div", { class: `arrow-container ${this.slidesLength >= 2 ? 'multiple' : ''}` }, arrowsData &&
          ((_a = arrowsData.elements) === null || _a === void 0 ? void 0 : _a.map((arrowComponent) => {
            var _a;
            if (arrowComponent && arrowComponent['name'] === 'aiba-button-prev')
              return (h("aiba-button", Object.assign({}, arrowComponent['data'], { disabled: !((_a = this.sliderProperties) === null || _a === void 0 ? void 0 : _a.loop) ? this.currentSlide === 0 : false, handleClick: (event) => this.handleClickPrev(event) })));
            if (arrowComponent && arrowComponent['name'] === 'aiba-button-custom-prev')
              return h("aiba-button", Object.assign({}, arrowComponent['data'], { handleClick: (event) => this.handleClickPrev(event) }));
            if (arrowComponent && arrowComponent['name'] === 'label') {
              return h("aiba-label", Object.assign({}, arrowComponent['data'], { text: this.lableData[this.currentSlide] }));
            }
            if (arrowComponent && arrowComponent['name'] === 'aiba-label' && arrowComponent['_id'] === 'text') {
              return h("aiba-label", Object.assign({}, arrowComponent['data'], { text: arrowComponent['data']['text'] }));
            }
            if (arrowComponent &&
              arrowComponent['name'] === 'aiba-label' &&
              arrowComponent['_id'] === 'customText' &&
              this.currentSlide !== this.slidesLength - slideInfo.slidesPerView) {
              return h("aiba-label", Object.assign({}, arrowComponent['data'], { text: arrowComponent['data']['text'] }));
            }
            if (arrowComponent &&
              arrowComponent['name'] === 'aiba-label' &&
              arrowComponent['_id'] === 'customLastSlideText' &&
              this.currentSlide === this.slidesLength - slideInfo.slidesPerView) {
              return h("aiba-label", Object.assign({}, arrowComponent['data'], { text: arrowComponent['data']['text'] }));
            }
            if (arrowComponent && arrowComponent['name'] === 'aiba-button-next')
              return (h("aiba-button", Object.assign({}, arrowComponent['data'], { disabled: this.currentSlide === this.slidesLength - Math.round(slideInfo.slidesPerView), handleClick: (event) => this.handleClickNext(event) })));
            if (arrowComponent && arrowComponent['name'] === 'aiba-button-custom-next')
              return h("aiba-button", Object.assign({}, arrowComponent['data'], { handleClick: (event) => this.handleClickNext(event) }));
          }))));
      }
      else if (this.sliderProperties && slideInfo.slidesPerView === this.slidesLength) {
        return (h("div", { class: "arrow-container" }, arrowsData &&
          ((_b = arrowsData.elements) === null || _b === void 0 ? void 0 : _b.map((arrowComponent) => {
            if (arrowComponent && arrowComponent['name'] === 'label') {
              return h("aiba-label", Object.assign({}, arrowComponent['data'], { text: this.lableData[this.currentSlide] }));
            }
          }))));
      }
    };
    this.renderDotsNavigation = dotsData => {
      let slideInfo = this.getSlideIndexInfo();
      if (this.sliderProperties && slideInfo.slidesPerView < this.slidesLength) {
        const dots = [];
        let slideCount = slideInfo.lastIndex;
        for (let i = 0; i < slideCount; i++) {
          dots.push(h("aiba-button", Object.assign({}, dotsData, { handleClick: (event) => this.handleMoveToSlideIndex(i, event), classes: `dot ${i === 0 ? 'dot--active' : ''} dot-${i}` })));
        }
        return dots;
      }
    };
    this.styles = undefined;
    this.classes = undefined;
    this.variation = 'arrows';
    this.data = undefined;
    this.moveToSliderIndex = false;
    this.children = undefined;
    this.handleSliderPrev = undefined;
    this.handleSliderNext = undefined;
    this.handleSliderMoveToIndex = undefined;
    this.disableTabbingInNonActiveSlides = false;
    this.handleSliderChange = undefined;
    this.handlers = undefined;
    this.sliderProperties = {
      slides: {
        perView: 1,
        spacing: 10,
      },
      loop: true,
      vertical: false,
      rubberband: false,
      mode: 'snap',
    };
    this.sliderLable = undefined;
    this.renderSliderOnTop = false;
    this.currentSlide = 0;
    this.firstLoad = true;
    this.contentData = undefined;
    this.slidesLength = undefined;
    this.lableData = [];
    this.headingData = [];
    this.scoreData = [];
    this.descriptionData = [];
  }
  tabchange(event) {
    console.log(event);
    this.currentSlide = 0;
    this.firstLoad = true;
    const dots = this.parentContainerRef.querySelectorAll('.dot');
    if (this.parentContainerRef.querySelector(`.dot-${this.currentSlide}`)) {
      dots.forEach(dot => dot.classList.remove('dot--active'));
      this.parentContainerRef.querySelector(`.dot-${this.currentSlide}`).classList.add('dot--active');
    }
  }
  tabchangecarousal(event) {
    console.log(event);
    this.currentSlide = 0;
    this.firstLoad = true;
    const dots = this.parentContainerRef.querySelectorAll('.dot');
    if (this.parentContainerRef.querySelector(`.dot-${this.currentSlide}`)) {
      dots.forEach(dot => dot.classList.remove('dot--active'));
      this.parentContainerRef.querySelector(`.dot-${this.currentSlide}`).classList.add('dot--active');
    }
  }
  findNodeWithKey(obj) {
    var _a, _b;
    const stack = [obj];
    const current = stack.pop();
    for (const key in current) {
      if ((_b = (_a = current[key]) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains('hydrated')) {
        return current[key];
      }
    }
    return current['$elm$'];
  }
  async componentWillLoad() {
    this.clientWidth = window.innerWidth;
    if (document.querySelector('aiba-app')) {
      this.clientWidth = document.querySelector('aiba-app').clientWidth;
    }
  }
  initSlider() {
    this.slider = new KeenSlider(this.swiperContainerRef, Object.assign(Object.assign({}, this.sliderProperties), { initial: this.currentSlide, slideChanged: s => {
        this.currentSlide = s.track.details.rel;
        //set active state for dot
        const dots = this.parentContainerRef.querySelectorAll('.dot');
        if (this.parentContainerRef.querySelector(`.dot-${this.currentSlide}`)) {
          dots.forEach(dot => dot.classList.remove('dot--active'));
          this.parentContainerRef.querySelector(`.dot-${this.currentSlide}`).classList.add('dot--active');
        }
        //additional handler from parent
        this.handleSliderChange && this.handleSliderChange(s);
      } }));
  }
  componentDidLoad() {
    // this.initSlider();
  }
  componentWillRender() {
    this.contentData = {
      heading: this.headingData ? this.headingData[this.currentSlide] : '',
      description: this.descriptionData ? this.descriptionData[this.currentSlide] : '',
      score: this.scoreData ? this.scoreData[this.currentSlide] : '',
      label: this.lableData ? this.lableData[this.currentSlide] : '',
    };
  }
  componentDidRender() {
    this.renderChildrenSlides();
  }
  componentWillUpdate() {
    if (this.handlers && this.handlers.handleSwipeCheck) {
      this.handlers && this.handlers.handleSwipeCheck && this.handlers.handleSwipeCheck();
    }
  }
  componentDidUpdate() {
    var _a, _b, _c;
    if (!this.disableTabbingInNonActiveSlides) {
      return;
    }
    const slidesArrayRef = (_b = (_a = this.parentContainerRef) === null || _a === void 0 ? void 0 : _a.querySelector('.keen-slider')) === null || _b === void 0 ? void 0 : _b.children;
    const slidesArray = (_c = Array.from(slidesArrayRef)) !== null && _c !== void 0 ? _c : [];
    if (!slidesArray.length) {
      return;
    }
    slidesArray.forEach((slide, index) => {
      const inert = this.getInertStateForSlide(index);
      if (inert) {
        slide.setAttribute('inert', '');
      }
      else {
        slide.removeAttribute('inert');
      }
    });
  }
  render() {
    var _a, _b;
    if (typeof this.data === 'string' || typeof this.sliderProperties === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
      if (this.sliderProperties)
        this.sliderProperties = JSON.parse(this.sliderProperties);
    }
    return (h(Host, null, h("div", { ref: el => (this.childrenSlidesSwiperRefNew = el), style: { display: 'none' } }, this.children), this.styles && h("style", null, this.styles), h("div", { class: "aiba-keen-slider-outer-wrapper", ref: el => (this.parentContainerRef = el) }, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((component) => {
        if (component && component['name'] === 'aiba-result-content-block') {
          return h("aiba-result-content-block", { data: component['data'], content: this.contentData ? this.contentData : component.data.text });
        }
        if (component && component['name'] === 'aiba-keen-slider')
          return this.renderSliderOnTop ? (h("div", { class: "aiba-keen-slider" }, h("div", { class: `keen-slider`, ref: el => (this.swiperContainerRef = el) }), h("div", { class: "children-slides-wrapper", ref: el => (this.childrenSlidesSwiperRef = el) }, h("slot", null)))) : (h("div", { class: "aiba-keen-slider" }, h("div", { class: "children-slides-wrapper", ref: el => (this.childrenSlidesSwiperRef = el) }, h("slot", null)), h("div", { class: `keen-slider`, ref: el => (this.swiperContainerRef = el) })));
        if (component && component['name'] === 'carousel-arrows' && (this.variation === 'arrows' || this.variation === 'arrowsWithDots'))
          return h("div", { class: "carousel-arrows" }, this.renderArrowsNavigation(component['data']));
        if (component && component['name'] === 'carousel-dots' && (this.variation === 'dots' || this.variation === 'arrowsWithDots'))
          return h("div", { class: "dot-container" }, this.renderDotsNavigation(component['data']));
      })))));
  }
  static get is() { return "aiba-carousel"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-carousel.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-carousel.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "variation": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'arrows' | 'dots' | 'arrowsWithDots'",
          "resolved": "\"arrows\" | \"arrowsWithDots\" | \"dots\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variation",
        "reflect": false,
        "defaultValue": "'arrows'"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "moveToSliderIndex": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "move-to-slider-index",
        "reflect": false,
        "defaultValue": "false"
      },
      "children": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "children",
        "reflect": false
      },
      "handleSliderPrev": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-slider-prev",
        "reflect": false
      },
      "handleSliderNext": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-slider-next",
        "reflect": false
      },
      "handleSliderMoveToIndex": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-slider-move-to-index",
        "reflect": false
      },
      "disableTabbingInNonActiveSlides": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-tabbing-in-non-active-slides",
        "reflect": false,
        "defaultValue": "false"
      },
      "handleSliderChange": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-slider-change",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "sliderProperties": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "slider-properties",
        "reflect": false,
        "defaultValue": "{\n    slides: {\n      perView: 1,\n      spacing: 10,\n    },\n    loop: true,\n    vertical: false,\n    rubberband: false,\n    mode: 'snap',\n  }"
      },
      "sliderLable": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "slider-lable",
        "reflect": false
      },
      "renderSliderOnTop": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "render-slider-on-top",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "currentSlide": {},
      "firstLoad": {},
      "contentData": {},
      "slidesLength": {},
      "lableData": {},
      "headingData": {},
      "scoreData": {},
      "descriptionData": {}
    };
  }
  static get events() {
    return [{
        "method": "prevClick",
        "name": "prevClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        }
      }, {
        "method": "nextClick",
        "name": "nextClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "event-recommended-products-changed",
        "method": "tabchange",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "event-recommended-products-changed-from-carousal",
        "method": "tabchangecarousal",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-carousel.js.map
